import { SerializedStyles, css, useTheme } from "@emotion/react"
import React from "react"
import { BodySubtextNormal } from "../typography/text"

interface BadgeProps extends React.HTMLProps<HTMLDivElement> {
  icon?: React.ReactNode
  children: React.ReactNode
  backgroundColor?: string
  additionalStyles?: SerializedStyles
}

export const Badge = ({
  icon,
  children,
  backgroundColor,
  additionalStyles,
  ...rest
}: BadgeProps) => {
  const BadgeStyles = css`
    display: flex;
    flex-direction: row;
    padding: 4px 8px;
    border-style: none;
    gap: 8px;
    background: ${backgroundColor ? backgroundColor : "rgba(0, 0, 0, 0.5)"};
    border-radius: 4px;
    width: fit-content;
    align-items: center;
    min-width: fit-content;
    ${additionalStyles}
  `
  const theme = useTheme()
  return (
    <div css={BadgeStyles} {...rest}>
      {icon && (
        <BodySubtextNormal color={theme.colors.white}>{icon}</BodySubtextNormal>
      )}
      {children}
    </div>
  )
}
